export default __webpack_public_path__ + "static/media/proposal-pending.89f0e6cc.svg";